export const cilTextShapes = ["24 24","<path d='M10.845 6.891l-3.793 9.609h2.117l0.731-1.852h4.201l0.731 1.852h2.117l-3.793-9.609zM10.676 12.679l1.324-3.353 1.324 3.353z'></path><path d='M23.25 6v-5.25h-5.25v1.875h-12v-1.875h-5.25v5.25h1.875v12h-1.875v5.25h5.25v-1.875h12v1.875h5.25v-5.25h-1.875v-12zM19.5 2.25h2.25v2.25h-2.25zM2.25 4.5v-2.25h2.25v2.25zM4.5 21.75h-2.25v-2.25h2.25zM21.75 19.5v2.25h-2.25v-2.25zM19.875 16.5v1.5h-1.875v1.875h-12v-1.875h-1.875v-12h1.875v-1.875h12v1.875h1.875z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-text-shapes.js
// module id = null
// module chunks = 